import React from 'react';
import './App.css';
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { Outlet } from 'react-router';
import { UserProvider } from './Context/useAuth';
import MainNavbar from './Components/Navbar/MainNavbar';
import Footer from './Components/Footer/Footer';

function App() {
  return (
    <div className='App'>
    <UserProvider>
      <MainNavbar />
      <Outlet />
      <ToastContainer />
      <Footer />
    </UserProvider>
    </div>
  );
}

export default App;